const VERSION_PARAM = 'version';

export const parseVersionParam = (params: URLSearchParams): number | null => {
  const raw = params.get(VERSION_PARAM);
  const parsed = raw === null ? NaN : Number(raw);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export const setVersionParam = (current: URLSearchParams, version: number | null): URLSearchParams => {
  const next = new URLSearchParams(current);
  if (version === null) {
    next.delete(VERSION_PARAM);
  } else {
    next.set(VERSION_PARAM, String(version));
  }
  return next;
};
